import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { ICONS } from "./constants";
import TeacherDetailProfileSection from "./TeacherDetailProfileSection";
import TeacherDetailContactActions from "./TeacherDetailContactActions";
import TeacherAccountLinkSection from "./TeacherAccountLinkSection";
import TeacherDetailInfoSection from "./TeacherDetailInfoSection";
import TeacherDetailVisitLogSection from "./TeacherDetailVisitLogSection";
import TeacherDetailTimelineSection from "./TeacherDetailTimelineSection";
import TeacherDetailNotesSection from "./TeacherDetailNotesSection";
import TeacherDetailFooterActions from "./TeacherDetailFooterActions";

export default function TeacherDetailModal({
  attendanceLogs,
  detailModalPos,
  editingLogId,
  fetchTeamMembers,
  handleDeleteTeacher,
  handleDetailMouseDown,
  handleLinkAccount,
  handleShareTeacher,
  handleUnlinkAccount,
  isMobile,
  isTeacher,
  linkLoading,
  logInputContent,
  logInputDate,
  logInputSentiment,
  logInputType,
  onAddLog,
  onClose,
  onEdit,
  onOpenCheerModal,
  onUpdateLog,
  openAlert,
  setEditingLogId,
  setLogInputContent,
  setLogInputDate,
  setLogInputSentiment,
  setLogInputType,
  setShowLinkPopup,
  showLinkPopup,
  teamMembers,
  theme,
  userProfile,
  visitLogs,
  viewingTeacher,
}) {
  if (!viewingTeacher) return null;

  return createPortal(
    <div className="fixed inset-0 bg-transparent flex items-center justify-center z-[1000] p-4 pointer-events-none" style={{ zIndex: 1000 }} onClick={onClose}>
      <div
        className="bg-white rounded-[2.5rem] w-full max-w-sm shadow-2xl relative overflow-hidden border border-white/50 max-h-[85vh] flex flex-col pointer-events-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ transform: `translate(${detailModalPos.x}px, ${detailModalPos.y}px)` }}
      >
        <div
          className="flex justify-between items-center px-6 py-5 border-b border-gray-100 z-20 shrink-0 cursor-move bg-white"
          onMouseDown={handleDetailMouseDown}
        >
          <h3 className="text-xl font-black text-[#2C3E30] flex items-center gap-2 font-do-hyeon">
            <img src={ICONS.pencil} width={28} alt="icon" /> 교사 상세 정보
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 p-2 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200"
            onMouseDown={(e) => e.stopPropagation()}
          >
            <X size={20} />
          </button>
        </div>

        <div className="w-full h-full overflow-y-auto custom-scrollbar p-0 flex flex-col">
          <div className="px-8 pb-10 pt-8 relative z-10 w-full flex flex-col select-text cursor-default">
            <TeacherDetailProfileSection teacher={viewingTeacher} />
            <TeacherDetailContactActions
              teacher={viewingTeacher}
              theme={theme}
              userProfile={userProfile}
              onOpenCheerModal={onOpenCheerModal}
            />

            <TeacherAccountLinkSection
              fetchTeamMembers={fetchTeamMembers}
              handleLinkAccount={handleLinkAccount}
              handleUnlinkAccount={handleUnlinkAccount}
              linkLoading={linkLoading}
              setShowLinkPopup={setShowLinkPopup}
              showLinkPopup={showLinkPopup}
              teamMembers={teamMembers}
              teacher={viewingTeacher}
              userProfile={userProfile}
            />

            <TeacherDetailInfoSection
              teacher={viewingTeacher}
              userProfile={userProfile}
            />

            <TeacherDetailVisitLogSection
              editingLogId={editingLogId}
              isMobile={isMobile}
              logInputContent={logInputContent}
              logInputDate={logInputDate}
              logInputSentiment={logInputSentiment}
              logInputType={logInputType}
              onAddLog={onAddLog}
              onUpdateLog={onUpdateLog}
              openAlert={openAlert}
              setEditingLogId={setEditingLogId}
              setLogInputContent={setLogInputContent}
              setLogInputDate={setLogInputDate}
              setLogInputSentiment={setLogInputSentiment}
              setLogInputType={setLogInputType}
              teacher={viewingTeacher}
              userProfile={userProfile}
            />

            <TeacherDetailTimelineSection
              attendanceLogs={attendanceLogs}
              teacher={viewingTeacher}
              userProfile={userProfile}
              visitLogs={visitLogs}
            />

            <TeacherDetailNotesSection
              teacher={viewingTeacher}
              userProfile={userProfile}
            />

            <TeacherDetailFooterActions
              handleDeleteTeacher={handleDeleteTeacher}
              handleShareTeacher={handleShareTeacher}
              isTeacher={isTeacher}
              onEdit={onEdit}
              teacher={viewingTeacher}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
